import { render, staticRenderFns } from "./InputButtonGo.vue?vue&type=template&id=1baf76ac&"
import script from "./InputButtonGo.vue?vue&type=script&lang=js&"
export * from "./InputButtonGo.vue?vue&type=script&lang=js&"
import style0 from "./InputButtonGo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports